import type { StorageKey } from "@exonn/storage";
import { localStorageDriver } from "src/storage/localeStorage.driver.ts";
import { autorun } from "mobx";

export const scheduleAction = ({
  storageKey,
  timeout,
  enabledWhen,
  action,
}: {
  timeout: number;
  enabledWhen: () => boolean;
  action: () => void;
  storageKey: StorageKey;
}) => {
  let timeoutId: null | NodeJS.Timeout = null;

  const getLastTimeEnabled = () => {
    return localStorageDriver.get<number>(storageKey);
  };
  const setLastTimeEnabled = (time: number | null) => {
    if (time != null) {
      return localStorageDriver.set<number>(storageKey, time);
    } else {
      localStorageDriver.remove(storageKey);
    }
  };

  const stopTimer = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  const startTimer = () => {
    if (timeoutId) {
      return;
    }
    const lastTimeEnabled = getLastTimeEnabled();
    const remaining = timeout - (Date.now() - (lastTimeEnabled ?? Date.now()));

    timeoutId = setTimeout(
      () => {
        action();
        setLastTimeEnabled(null);
        timeoutId = null;
      },
      Math.max(remaining, 0),
    );
  };

  return autorun(() => {
    const debugDbQueries = enabledWhen();

    if (debugDbQueries) {
      if (!getLastTimeEnabled()) {
        setLastTimeEnabled(Date.now());
      }

      startTimer();
    } else {
      setLastTimeEnabled(null);
      stopTimer();
    }
  });
};
